import { useState } from 'react';
import SectionHeading from '../../components/ui/SectionHeading/SectionHeading.jsx';
import Card from '../../components/ui/Card/Card.jsx';
import Button from '../../components/ui/Button/Button.jsx';
import Badge from '../../components/ui/Badge/Badge.jsx';
import FAQ from '../../components/home/FAQ/FAQ.jsx';
import { pricingPlans, comparisonRows } from '../../data/pricingPlans.js';
import styles from './Plans.module.css';

export default function Plans() {
  const [yearly, setYearly] = useState(false);

  return (
    <>
      <section className={styles.hero}>
        <div className="container">
          <Badge tone="secondary">Plans</Badge>
          <h1 className={styles.title}>Simple pricing that scales with your launch</h1>
          <p className={styles.lead}>Start for free, upgrade when your product needs more room.</p>

          <div className={styles.toggle}>
            <span className={!yearly ? styles.toggleActive : ''}>Monthly</span>
            <button
              className={styles.switch}
              role="switch"
              aria-checked={yearly}
              onClick={() => setYearly((v) => !v)}
            >
              <span className={`${styles.knob} ${yearly ? styles.knobOn : ''}`} />
            </button>
            <span className={yearly ? styles.toggleActive : ''}>Yearly <Badge tone="secondary">2 months free</Badge></span>
          </div>
        </div>
      </section>

      <section className={styles.section}>
        <div className={`container ${styles.grid}`}>
          {pricingPlans.map((plan) => {
            const price = yearly ? plan.yearly : plan.monthly;
            return (
              <Card key={plan.id} className={`${styles.planCard} ${plan.highlighted ? styles.highlighted : ''}`} hover={false}>
                {plan.highlighted && <span className={styles.popular}>Most popular</span>}
                <h2 className={styles.planName}>{plan.name}</h2>
                <p className={styles.planTagline}>{plan.tagline}</p>
                <div className={styles.priceRow}>
                  <span className={styles.price}>${price}</span>
                  <span className={styles.pricePeriod}>/{yearly ? 'yr' : 'mo'}</span>
                </div>
                <Button
                  to="/contact"
                  variant={plan.highlighted ? 'primary' : 'secondary'}
                  size="md"
                  className={styles.planCta}
                >
                  {plan.cta}
                </Button>
                <ul className={styles.featureList}>
                  {plan.features.map((f) => (
                    <li key={f} className={styles.feature}>{f}</li>
                  ))}
                </ul>
              </Card>
            );
          })}
        </div>
      </section>

      <section className={styles.section}>
        <div className="container">
          <SectionHeading eyebrow="Compare" title="Every feature, side by side" />
          <div className={styles.tableWrap}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th></th>
                  <th>Starter</th>
                  <th>Growth</th>
                  <th>Scale</th>
                </tr>
              </thead>
              <tbody>
                {comparisonRows.map((row) => (
                  <tr key={row.label}>
                    <td className={styles.rowLabel}>{row.label}</td>
                    <td>{renderCell(row.starter)}</td>
                    <td>{renderCell(row.growth)}</td>
                    <td>{renderCell(row.scale)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <FAQ />
    </>
  );
}

function renderCell(value) {
  if (value === true) return <span className={styles.check}>✓</span>;
  if (value === false) return <span className={styles.dash}>—</span>;
  return value;
}
